import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function CtaSection() {
  const ref = useScrollReveal<HTMLDivElement>({ stagger: 0.12 });

  return (
    <section ref={ref} className="relative bg-[#050505] text-white py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Sweeping%20cinematic%20abstract%20background%20of%20warm%20amber%20and%20deep%20charcoal%20light%20beams%20diffusing%20through%20a%20soft%20foggy%20studio%20atmosphere%2C%20premium%20editorial%20technology%20composition%20with%20deep%20negative%20space%20and%20a%20single%20glowing%20horizon%20line&width=1800&height=900&seq=vex-cta-bg&orientation=landscape"
          alt="Vex backdrop"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/30 to-[#050505]" />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 md:px-10 lg:px-16 text-center">
        <div className="gsap-reveal text-[11px] font-mono uppercase tracking-[0.3em] text-white/50 mb-6">
          // building the next decade
        </div>
        <h2 className="gsap-reveal font-display text-4xl md:text-6xl lg:text-7xl leading-[1.05] mb-8 cursor-default">
          <span className="title-shimmer-auto inline-block">
            If you are building something that should exist — talk to us.
          </span>
        </h2>
        <p className="gsap-reveal text-white/60 max-w-2xl mx-auto mb-10 text-base md:text-lg">
          Whether you are at the napkin stage or shipping in production, we read every note.
          Bring us your most ambitious idea — we will reply within 72 hours.
        </p>
        <div className="gsap-reveal flex flex-wrap gap-3 justify-center">
          <Link
            to="/advisory"
            className="bg-white text-black px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Start a Chat
            <i className="ri-arrow-right-up-line"></i>
          </Link>
          <a
            href="mailto:hello@vex.vc"
            className="liquid-glass border border-white/20 text-white px-8 py-3 rounded-lg font-medium hover:bg-white hover:text-black transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            hello@vex.vc
            <i className="ri-mail-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}